import { FC } from 'react';

import useAuthenticatedAction from 'common/hooks/useAuthenticatedAction';
import { Scope } from 'common/hooks/useAuthenticatedAction/types';
import Loader from 'components/Loader';
import PasscodeInput from 'components/PasscodeInput';

import locales from './locales';
import * as S from './styles';

interface Props {
  onConfirmationSuccess: (shortLiveToken: string) => Promise<void>;
}

const SidebarConfirmationPasscode: FC<Props> = (props) => {
  const { onConfirmationSuccess } = props;

  const { isLoading, onPasscodeSubmit } = useAuthenticatedAction({
    onPasscodeSuccess: onConfirmationSuccess,
    scope: Scope.BANK_DIRECT_DEBIT_WRITE,
  });

  return (
    <S.Root>
      <S.Title>{locales.title}</S.Title>
      <S.SubTitle>{locales.subTitle}</S.SubTitle>

      {isLoading ? (
        <S.LoaderWrapper>
          <Loader />
        </S.LoaderWrapper>
      ) : (
        <PasscodeInput hidden onSubmit={onPasscodeSubmit} />
      )}
    </S.Root>
  );
};

export default SidebarConfirmationPasscode;
